// extracted by mini-css-extract-plugin
export default {"container":"UploadModal_container__IT758","upload":"UploadModal_upload__pVL1B","mergeOptions":"UploadModal_mergeOptions__lq-kF","dropContainer":"UploadModal_dropContainer__TDEnc"};